import { BigNumber } from 'ethers'
import { DepositLimit } from '../types/DepositLimit'
import { isLimitExceeds } from './isLimitExceeds'

export const LIMIT_ERRORS_DEPOSIT = {
  exceedsDailyLimit: (
    <>
      Given amount exceeds daily deposit limit for the given pool. Please reduce
      the amount. If you want to deposit this amount, please{' '}
      <a
        href="https://share-eu1.hsforms.com/1QZ5Yn3O_S_22GWVHcZ-SUwf76n7"
        target="_blank"
        rel="noreferrer"
      >
        join the waitlist
      </a>
    </>
  ),
  exceedsGlobalLimit: (
    <>
      Given amount exceeds total deposit limit for the given pool. Please reduce
      the amount. If you want to deposit this amount, please{' '}
      <a
        href="https://share-eu1.hsforms.com/1QZ5Yn3O_S_22GWVHcZ-SUwf76n7"
        target="_blank"
        rel="noreferrer"
      >
        join the waitlist
      </a>
    </>
  ),
}

export type LimitErrorArgs = { amountWei: BigNumber } & DepositLimit

export const getLimitErrorDeposit = ({
  totalValue,
  dailyValue,
  poolDailyLimit,
  poolGlobalLimit,
  amountWei,
}: LimitErrorArgs) => {
  if (isLimitExceeds(amountWei, dailyValue, poolDailyLimit)) {
    return LIMIT_ERRORS_DEPOSIT.exceedsDailyLimit
  }

  if (isLimitExceeds(amountWei, totalValue, poolGlobalLimit)) {
    return LIMIT_ERRORS_DEPOSIT.exceedsGlobalLimit
  }

  return null
}
